// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Figtree', 'Figtree Fallback'","fontStyle":"normal"},"className":"__className_2ca027","variable":"__variable_2ca027"};